import React from 'react';
import { Modal } from './ui/Modal';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Política de Privacidad" data-id="element-171">
      <div className="prose prose-sm max-w-none text-gray-700 space-y-6" data-id="element-172">
        <p className="text-sm text-gray-500 italic" data-id="element-173">
          Última actualización: Diciembre 2024
        </p>

        <section data-id="element-174">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-175">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-176">
            Al realizar una compra de "Casa Impecable con 2 Ingredientes",
            recopilamos la siguiente información:
          </p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-177">
            <li data-id="element-178">
              <strong data-id="element-179">Información personal:</strong> Nombre, dirección de correo
              electrónico
            </li>
            <li data-id="element-180">
              <strong data-id="element-181">Información de pago:</strong> Procesada de forma segura
              por nuestros proveedores de pago (no almacenamos datos de
              tarjetas)
            </li>
            <li data-id="element-182">
              <strong data-id="element-183">Información técnica:</strong> Dirección IP, tipo de
              navegador, páginas visitadas
            </li>
          </ul>
        </section>

        <section data-id="element-184">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-185">
            2. Cómo Usamos tu Información
          </h3>
          <p data-id="element-186">Utilizamos la información recopilada para:</p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-187">
            <li data-id="element-188">Procesar tu compra y entregarte el producto digital</li>
            <li data-id="element-189">Enviarte confirmaciones de pedido y enlaces de descarga</li>
            <li data-id="element-190">Proporcionar soporte al cliente</li>
            <li data-id="element-191">
              Enviarte actualizaciones del producto (si has dado tu
              consentimiento)
            </li>
            <li data-id="element-192">Mejorar nuestro sitio web y servicios</li>
            <li data-id="element-193">Prevenir fraudes y garantizar la seguridad</li>
          </ul>
        </section>

        <section data-id="element-194">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-195">
            3. Cookies y Tecnologías Similares
          </h3>
          <p data-id="element-196">
            Utilizamos cookies y tecnologías similares para mejorar tu
            experiencia en nuestro sitio web. Las cookies nos ayudan a:
          </p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-197">
            <li data-id="element-198">Recordar tus preferencias</li>
            <li data-id="element-199">Analizar el tráfico del sitio web</li>
            <li data-id="element-200">Personalizar el contenido</li>
          </ul>
          <p className="mt-2" data-id="element-201">
            Puedes configurar tu navegador para rechazar cookies, aunque esto
            puede afectar la funcionalidad del sitio.
          </p>
        </section>

        <section data-id="element-202">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-203">
            4. Compartir Información con Terceros
          </h3>
          <p data-id="element-204">
            No vendemos ni alquilamos tu información personal. Compartimos
            información solo con:
          </p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-205">
            <li data-id="element-206">
              <strong data-id="element-207">Procesadores de pago:</strong> Para completar
              transacciones de forma segura
            </li>
            <li data-id="element-208">
              <strong data-id="element-209">Proveedores de servicios:</strong> Que nos ayudan a operar
              nuestro negocio (hosting, email)
            </li>
            <li data-id="element-210">
              <strong data-id="element-211">Autoridades legales:</strong> Si es requerido por ley
            </li>
          </ul>
        </section>

        <section data-id="element-212">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-213">
            5. Seguridad de los Datos
          </h3>
          <p data-id="element-214">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o alteración. Sin embargo, ningún método de transmisión por
            Internet es 100% seguro.
          </p>
        </section>

        <section data-id="element-215">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-216">
            6. Tus Derechos
          </h3>
          <p data-id="element-217">Tienes derecho a:</p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-218">
            <li data-id="element-219">
              <strong data-id="element-220">Acceder:</strong> Solicitar una copia de tu información
              personal
            </li>
            <li data-id="element-221">
              <strong data-id="element-222">Rectificar:</strong> Corregir información inexacta
            </li>
            <li data-id="element-223">
              <strong data-id="element-224">Eliminar:</strong> Solicitar la eliminación de tu
              información
            </li>
            <li data-id="element-225">
              <strong data-id="element-226">Oponerte:</strong> Oponerte al procesamiento de tu
              información
            </li>
            <li data-id="element-227">
              <strong data-id="element-228">Portabilidad:</strong> Recibir tu información en formato
              estructurado
            </li>
          </ul>
          <p className="mt-2" data-id="element-229">
            Para ejercer estos derechos, contáctanos en:
            privacidad@casaimpecable.com
          </p>
        </section>

        <section data-id="element-230">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-231">
            7. Marketing por Email
          </h3>
          <p data-id="element-232">
            Si has dado tu consentimiento, podemos enviarte correos electrónicos
            sobre actualizaciones del producto, ofertas especiales o contenido
            relacionado. Puedes darte de baja en cualquier momento haciendo clic
            en el enlace de cancelación de suscripción en cualquier email.
          </p>
        </section>

        <section data-id="element-233">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-234">
            8. Retención de Datos
          </h3>
          <p data-id="element-235">
            Conservamos tu información personal solo durante el tiempo necesario
            para cumplir con los fines descritos en esta política, a menos que
            la ley requiera o permita un período de retención más largo.
          </p>
        </section>

        <section data-id="element-236">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-237">
            9. Cambios a esta Política
          </h3>
          <p data-id="element-238">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos publicando la nueva
            política en nuestro sitio web y actualizando la fecha de "última
            actualización".
          </p>
        </section>

        <section data-id="element-239">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-240">10. Contacto</h3>
          <p data-id="element-241">
            Si tienes preguntas sobre esta política de privacidad, contáctanos
            en:
            <br data-id="element-242" />
            Email: privacidad@casaimpecable.com
            <br data-id="element-243" />
            Desarrollado por Emily Graterol
          </p>
        </section>
      </div>
    </Modal>;
}